import SpaIcon from '@mui/icons-material/Spa';
import { SeedlingList } from './SeedlingList';
import { SeedlingCreate } from './SeedlingCreate';

export default {
	list: SeedlingList,
	create: SeedlingCreate,
	icon: SpaIcon,
};